import { createModel } from '@rematch/core';
import { CheckOutQuestion } from '../../models/check-out-question';
import { storeByIMPSId } from '../../utils/converter';
import { getCheckOutQuestions } from '../../apis/check-out-question';

export interface State {
    byId: Dictionary<CheckOutQuestion>;
    loading: Dictionary<boolean>;
}

export const checkOutQuestions = createModel<State>({
    state: {
        byId: {},
        loading: {}
    },
    reducers: {
        update: (
            state: State,
            data: Undefinable<MixType<CheckOutQuestion>>,
            loadingKey?: string
        ): State => {
            const hasData = Array.isArray(data) ? data.length > 0 : data;
            if (hasData || loadingKey) {
                return {
                    ...state,
                    ...data && {
                        byId: {
                            ...state.byId,
                            ...storeByIMPSId(data)
                        }
                    },
                    ...loadingKey && {
                        loading: {
                            ...state.loading,
                            [loadingKey]: false
                        }
                    }
                };
            } else {
                return state;
            }
        },
        loading: (
            state: State,
            loadingKey: string,
            loading: boolean
        ): State => ({
            ...state,
            loading: {
                ...state.loading,
                [loadingKey]: loading
            }
        })
    },
    effects: () => ({
        async getCheckOutQuestionsAsync(appointmentId: number) {
            this.loading('getCheckOutQuestionsAsync', true);
            try {
                const data = await getCheckOutQuestions(appointmentId);
                this.update(data, 'getCheckOutQuestionsAsync');
            } catch (e) {
                window.console.log(e);
                this.loading('getCheckOutQuestionsAsync', false);
            }
        }
    })
});
